import { Component, ChangeDetectorRef } from '@angular/core';
import { FoodsProvider } from '../../providers/foods/foods';
import { Day } from '../../models/day.model';
import { Events, ModalController, PopoverController } from 'ionic-angular';
import { MenuFoodsPage } from './menu-foods/menu-foods';
import { MenuCustomersPage } from './menu-customers/menu-customers';
import { ModalDetailPage } from './modal-detail/modal-detail';
import { Params } from "../params";
import { GlobalProvider } from '../../providers/global/global';

/**
 * Generated class for the DaysPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-days',
  templateUrl: 'days.html',
})
export class DaysPage {
  filters = {
    distpach: true,
    inactive_type: "all",
    active_type: "all",
    food: null
  }
  prodType = Params.prodType;
  foods = [];
  constructor(
    public foodServ: FoodsProvider,
    public popoverCtrl: PopoverController,
    public modalCtrl: ModalController,
    public events: Events,
    private ref: ChangeDetectorRef,
    public global: GlobalProvider) {

    this.events.subscribe('filters_change', (filters) => {
      console.log("filters_change");
      console.log('foodServ', this.foodServ.activeDay.foods);
      this.filters = filters;

      this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
        return item.shipping.delivered == this.filters.distpach
      });

      if (this.filters.food != null) {
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
          return item.shipping.delivered == this.filters.distpach
            && item.foods.hired.indexOf(this.filters.food) != -1
        });
      }

      if (!this.filters.distpach && this.filters.inactive_type != 'all') {
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
          return (item.shipping.no_shipping_reason == this.filters.inactive_type) && item.shipping.delivered == this.filters.distpach
        });
      }

      if (this.filters.distpach && this.filters.active_type == 'rest') {
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
          return item.shipping.delivered == this.filters.distpach
            && item.foods.restrictions.detail.length
        });
      }

      if (this.filters.distpach && this.filters.active_type == 'rest' && this.filters.food != null) {
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
          return item.shipping.delivered == this.filters.distpach
            && item.foods.restrictions.detail.length
            && item.foods.hired.indexOf(this.filters.food) != -1
        });
      }

      if (this.filters.distpach && this.filters.active_type == 'cond') {
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
          return item.shipping.delivered == this.filters.distpach
            && Object.keys(item.customer.conditions).length && Object.keys(item.customer.conditions).filter((x) => item.foods.hired.includes(x)).length
        });
      }

      if (this.filters.distpach && this.filters.active_type == 'cond' && this.filters.food != null) {
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
          return item.shipping.delivered == this.filters.distpach
            && Object.keys(item.customer.conditions).length
            && Object.keys(item.customer.conditions).indexOf(this.filters.food) != -1
        });
      }

    });
    this.foods = this.global.foods;
  }

  showConditions(item?) {
    return Object.keys(item.customer.conditions).length;
  }

  infoConditions(item?) {
    let conds = Object.keys(item.customer.conditions);
    console.log('🌟 -> file: days.ts:100 -> DaysPage -> infoConditions -> item.customer', item)
    let txt = [];
    for (let c of conds) {
      let food = this.foods.filter((f: any) => f.value === c);
      if (food && item.foods.hired.includes(c)) {
        txt.push('[' + c + '] ' + food[0]?.name + ': ' + item.customer.conditions[c]);
      }
    }
    return txt;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DaysPage');
  }

  removeFoodFilter() {
    this.filters.food = null;
    this.events.publish('filters_change', this.filters)
  }


  countRestrictionSolved() {
    const f = this.foodServ.activeDay.charge.data.filter((item) => {
      return item.shipping.delivered == this.filters.distpach
        && (this.filters.active_type == 'rest' && item.foods.restrictions.detail.length && item.foods.restrictions.solved)
    });
    return f.length;
  }

  getItems(ev) {
    let val = ev.target.value;
    this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
      return item.shipping.delivered == this.filters.distpach
    });

    if (val && val.trim() != '') {
      this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((item) => {
        return item.shipping.delivered == this.filters.distpach && ((item.customer.name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.customer.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }

  processCustomers() {
    console.log('foodsServ', this.foodServ.activeDay);
    this.foodServ.process(this.foodServ.activeDay).then((ok) => {
      this.foodServ.activeDay.charge.exists = true;
      this.loadCustomers();
    })
  }

  loadCustomers() {
    this.foodServ.activeDay.loading = true;
    this.foodServ.activeDay.load()
      .then(() => {
        console.log("detect"!);
        this.foodServ.activeDay.charge.filtered = this.foodServ.activeDay.charge.data.filter((x) => x.shipping.delivered)
        //this.ref.detectChanges();
      });
  }


  foodsMenu(ev) {
    let popover = this.popoverCtrl.create(MenuFoodsPage);
    popover.present({
      ev: ev
    });
  }

  customersMenu(ev, mode) {
    let popover = this.popoverCtrl.create(MenuCustomersPage, { mode: mode, filters: this.filters });
    popover.present({
      ev: ev
    });
  }

  addDays() {
    this.foodServ.moreDays();
  }

  viewDay(day: Day) {
    day.filterDay();
    this.removeActives();
    this.foodServ.activeDay = day;
    this.foodServ.activeDay.active = true;
    this.foodServ.activeDay.charge.filtered = day.charge.data.filter((x) => x.shipping.delivered);

  }

  removeActives() {
    this.foodServ.days.map((d) => {
      d.active = false;
      return d;
    })
  }

  viewFoods(f) {
    this.filters.food = f;
    this.events.publish('filters_change', this.filters)
  }

  imageURL(p) {
    let url = 'assets/img/photo.jpg';
    if (p.prod.length) {
      if (p.prod[0].imageList.length) {
        url = p.prod[0].imageList[0].downloadURL;
      }
    }
    return url;
  }

  seeMore(type, c) {
    let modal = this.modalCtrl.create(ModalDetailPage, {
      data: {
        charge: c,
        day: this.foodServ.activeDay
      }
    });
    modal.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/days/days.ts